import {Feedback} from '../../modules'

export const FeedbackPage = () => {
  return <Feedback />
}
